import {css} from "@emotion/react";
import React from 'react';
import {useHistory} from "react-router-dom";
import {useLocationById} from "../../../../sdk/queries";
import {useIdvsExceededByDate} from "../../../../sdk/queries";
import {useIdvsExceededByPeriod} from "../../../../sdk/queries";
import {useIdvsByPeriod} from "../../../../sdk/queries";
import {tracksideMonitoring,tsmTopFive} from "../../../Routes/urls";
import {Grid} from "../../../Grid";
import {Card} from "../../../TabsRoute/components/Card";
import {column, numberOfCallsText, row, textTotal, textTotalNumber, total, nsCarDiv} from "../../styles";
import {TSMMonitoringContext} from "../TSMMonitoringProvider";
import {DustFreeSvg} from "../DustFreeSvg";
import nsCar from "../../../../images/ns-car.png"

export const DustAlerts = ({location_id, period_s}:
			   {location_id: number; period_s: string}) => {
    const history = useHistory();
    const {callLogs} = React.useContext(TSMMonitoringContext);
    const url_suffix = location_id + "/mines/" + period_s 

    const {data, loading} = useLocationById({
	variables: {
	    id: String(location_id),
	}
    });

    const location = data?.data;
    
    const e_idvs = useIdvsExceededByPeriod({
	variables: {
	    location_id: String(location_id),
	    period_date: period_s,
	}
    });

    const exceeded = (e_idvs?.data?.data || []);

    console.log(exceeded);

    const idvs = useIdvsByPeriod({
	variables: {
	    id: String(location_id),
	    period_date: period_s,
	}
    });

    const all_idvs = (idvs?.data?.data || []);
    
    return (
        <Card padding={"0 40px"} contentCss={css({backgroundColor: "#F7FBFF", cursor: "pointer"})}>
            <div css={column}
	        onClick={() =>
		    history.push(tracksideMonitoring+url_suffix)}>
                <div css={row}>
                    <div css={total}>
                        <p css={textTotal}>{location?.name}</p>
                    </div>
                </div>
                <div css={row}>
            <div css={nsCarDiv}>
                        <img width="150px" src={nsCar} />
                    </div>
                </div>
                <div css={row}>
	            <p css={numberOfCallsText}>High Dust Alert:</p>
                    <p css={textTotalNumber}>{exceeded.length}</p>
                </div>
                <div css={row}>
                    <p css={numberOfCallsText}>Total # Trains Monitored: {all_idvs.length}</p>
                </div>
            </div>
        </Card>
    );
};
